import { reactive, computed, onBeforeMount, watch } from '@vue/composition-api'
import { formatDate, breakComma, isPc } from '@/util/common'
import * as _ from 'lodash'
import { openPrecedentDetail } from '@/logic/common/CommonPrecedent'

export const BookmarkList = (props, context) => {
  const store = context.root.$store
  const router = context.root.$router
  const { bookmark } = store.state

  const data = reactive({
    // 日付でソートされたリスト
    lists: computed(() => bookmark.lists),
    count: computed(() => bookmark.count),
    // 絞り込みはAPI側で実行するため、日付のグルーピングのみおこなう
    groupDateLists: computed(() => {
      const list = _.groupBy(data.lists, 'created')
      return list
    }),
    // 全読み込み済みフラグ
    complete: computed(() => bookmark.complete),
    canload: computed(() => bookmark.canload),
    tags: [],
    allTags: computed(() => {
      const tags = _.reject(data.tags, tag => _.map(data.filterTags, 'name').includes(tag.name))
      return _.uniqBy(tags, 'name')
    }),
    filterTags: []
  })

  const state = reactive({
    visibleToast: false,
    visibleBookmarkEdit: false,
    visibleBookmarkDeleteConfirm: false,
    additionalLoading: true,
    canload: true,
    visibleMenu: false, // SP用
    vieibleBookmarkTagExtract: false, // SP用
    visibleBookmarkConditionEdit: false, // SP用
    visibleDeleteConfirm: false, // SP用
    isOpenMenu: false // SP用
  })

  // タグの絞り込みを監視し、変更があればリストをリセットする
  watch(() => data.filterTags, (newVal, oldVal) => {
    if (!oldVal) return
    const tagNames = _.map(newVal, tag => tag.id)
    debounceFilterTags(tagNames)
  })
  
  // 連続押下時にAPIを連続で呼ばないように間隔をあけて実行する
  const debounceFilterTags = _.debounce((params) => {
    store
      .dispatch('bookmark/setFilterTags', params)
      .then(() => {
        store.dispatch('bookmark/resetLists')
      })
  }, 500)

  const action = {
    start: () => {
      store.commit('bookmark/resetState')
    },
    load: () => {
      store.dispatch('bookmark/getLists')
    },
    loadTags: () => {
      store
        .dispatch('bookmark/getTags')
        .then(() => {
          data.tags = bookmark.tags
        })
    },
    setTags: (changeTag) => {
      const tagsIndex = _.findIndex(data.tags, tag => tag.name === changeTag.name)
      data.tags.splice(tagsIndex, 1)
      data.filterTags.push(changeTag)
    },
    resetTags: (changeTag) => {
      data.tags.push(changeTag)
      const tagsIndex = _.findIndex(data.filterTags, tag => tag.name === changeTag.name)
      data.filterTags.splice(tagsIndex, 1)
    },
    editItem: (id) => {
      store.dispatch('bookmark/setEditId', id)
      state.visibleBookmarkEdit = true
    },
    deleteItem: (id) => {
      store.dispatch('bookmark/setEditId', id)
      state.visibleBookmarkDeleteConfirm = true
    },
    routeList: (list) => {
      // 遷移先とstoreのアクション名を設定
      switch (list.type) {
        case 'qa':
          if (list.latest_id !== 0) {
            if (isPc()) {
              router.push({ name: 'PCQADetail', params: { qaId: list.latest_id } })
            } else {
              router.push({ name: 'SPQADetail', params: { qaId: list.latest_id } })
            }
          } else {
            if (isPc()) {
              router.push({ name: 'PCQADetail', params: { qaId: list.id } })
            } else {
              router.push({ name: 'SPQADetail', params: { qaId: list.id } })
            }
          }
          break
        case 'knowledge':
          if (isPc()) {
            router.push({ name: 'PCKnowledgeDetail', params: { knowledgeId: list.id } })
          } else {
            router.push({ name: 'SPKnowledgeDetail', params: { knowledgeId: list.id } })
          }
          break
        case 'pj':
          // 資料検索の詳細画面を別ウィンドウで開く
          if (list.latest_id !== 0) {
            openPrecedentDetail(list.latest_id)
          } else {
            openPrecedentDetail(list.id)
          }
          break

      }
    },
    routeTaglist: () => {
      store.dispatch('tag/changeType', 'bookmark')
      router.push({ name: 'PCTagList' })
    }
  }

  // 初回リスト読み込みはPCScrollListのイベントにて発火
  // action.load()
  action.start()
  // タグ読み込み
  action.loadTags()

  return {
    state,
    data,
    formatDate,
    breakComma,
    action
  }
}
